export default __webpack_public_path__ + "static/media/identity.04780902.svg";